var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box"},[_c('ul',{staticStyle:{"min-height":"400px"}},_vm._l((_vm.lists),function(item,index){return _c('li',{key:'l' + index},[_c('router-link',{attrs:{"to":{
            path: '/detail',
            query: {
              newstype: item.newstype,
              id: item.id,
            },
          }}},[_c('p',{staticClass:"news-title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.addtime))])])],1)}),0),_vm._v(" "),_c('div',{staticClass:"fenye man-top20"},[_c('el-pagination',{attrs:{"current-page":_vm.page,"page-size":_vm.pageSize,"layout":"total, prev, pager, next, jumper","total":_vm.total},on:{"current-change":_vm.handleCurrentChange}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a11616ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/list/list.vue
// module id = null
// module chunks = 